export default function($) {
  $('.js-product-thumb').on('click', function() {
    var srcMediumLarge = $(this).data( 'mediumlarge' ),
        srcXXLarge = $(this).data( 'xxlarge' ),
        alt = $(this).attr( 'alt' ),
        title = $(this).attr( 'title' );

    $(this).parents('.js-product-gallery').find('.js-product-image').attr( 'src', srcMediumLarge );
    $(this).parents('.js-product-gallery').find('.js-product-zoom').attr( 'href', srcXXLarge );
    $(this).parents('.js-product-gallery').find('.js-product-zoom').attr( 'data-title', title );
    $(this).parents('.js-product-gallery').find('.js-product-zoom').attr( 'data-alt', alt );
  })
}
